var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMiddleFingerWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 625 625",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 1.5
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    id: "Lean-Thick",
    d: "M213.185,591.091l8.655,5.36c29.508,-0.087 158.713,-0.469 186.319,-0.55l8.045,-4.396c12.137,-18.88 59.52,-94.363 70.818,-139.362c11.94,-47.558 8.526,-125.754 3.842,-157.222c-1.926,-12.936 -11.935,-29.097 -31.02,-29.987c-12.229,-0.571 -22.606,8.556 -27.253,13.44l-2.616,6.561c-0.029,14.391 -0.138,67.168 -0.138,67.168c0,0 0.136,-65.983 0.145,-70.51l-0.024,-0.627c-0.217,-3.117 -1.989,-24.55 -10.545,-37.796c-6.721,-10.406 -18.309,-14.538 -27.709,-14.466c-20.257,0.154 -29.312,12.817 -32.205,18.087l-1.118,4.315c-0.138,12.906 -0.874,82.256 -0.874,82.256c-0,-0 0.855,-80.521 0.894,-84.181l0.006,-0.264c0.194,-5.138 5.825,-155.786 0.877,-190.502c-1.709,-11.991 -6.764,-29.94 -31.81,-29.883c-18.406,0.042 -29.357,8.63 -33.813,26.276c-3.689,14.608 -9.508,205.222 -11.823,273.296l0.162,-3.385c0.671,-19.442 1.653,-78.01 1.869,-84.27l-0.922,-4.278c-2.583,-5.262 -11.165,-17.146 -36.071,-17.382c-24.354,-0.232 -33.702,19.588 -35.887,33.94c-2.85,18.719 -4.24,48.944 -4.325,50.843l-0.009,0.17c-0.089,1.455 0.203,9.749 -0.083,14.392c-0,-0 -10.432,50.994 -13.28,74.336c-3.626,29.719 -3.613,45.393 -3.613,45.393c0,-0 0.663,-15.955 3.613,-45.393c2.706,-27.005 13.059,-69.127 13.28,-74.336l-12.659,-9.949c-3.991,1.395 -8.144,2.822 -11.198,3.814c-16.245,5.273 -31.036,5.182 -37.189,16.99c-10.814,20.756 -19.37,88.578 -14.543,122.857c4.431,31.472 39.874,61.203 54.015,85.307c8.743,14.903 22.464,42.357 28.187,53.938Z",
    style: {
      fill: "none",
      stroke: "#fff",
      strokeWidth: "45.35px"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMiddleFingerWhite);
export default __webpack_public_path__ + "static/media/middle-finger-white.f124f571.svg";
export { ForwardRef as ReactComponent };